const ceilify = function ceilify(number: Number, digits = 2) {
  if (typeof number !== "number") return NaN;
  const factor =
    digits < 0 ? Math.pow(0.1, Math.abs(digits)) : Math.pow(10, digits);
  return Math.ceil(number * factor) / factor;
};

export default ceilify;
